module.exports = __webpack_public_path__ + "static/media/bod01.07242575.jpg";